import toast from "bootstrap/js/src/toast";
import {showErrorMessage} from "@/helper";

export default {
    getStatsTable(body) {
        return new Promise((resolve, reject) => {
            http.post('api/reports/stats-table', body).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getStatsTableRowStats(params) {
        return new Promise((resolve, reject) => {
            http.get('api/reports/stats-table-row-stats', { params }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(null);
            });
        });
    },
    getStatsHistory(body) {
        return new Promise((resolve, reject) => {
            http.post('api/reports/stats-history', body).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getTotalStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/total-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getContractsTypesCountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/contracts-types-count-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getContractsTypesAmountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/contracts-types-amount-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getStrategiesCountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/strategies-count-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getStrategiesAmountStats() {
        return new Promise((resolve, reject) => {
            http.get('api/reports/strategies-amount-stats', {}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    
}